import crminfo from './crminfo.staging.js';

const apiAuthUrl = 'https://oauth-stage.dsh-agency.com';
const apiAuthBackUrl = 'https://auth-back-stage.dsh-agency.com';
const apiSentry ='https://dead0a4f63b646f0bdb16745fd896eca@o255621.ingest.sentry.io/6697831';
const apiSmsTool ='https://connect-stage.dsh-agency.com';
const isProductionMode = false

const urls = {
    login: apiAuthUrl,
    logout: apiAuthUrl + '/logout',
    me: apiAuthBackUrl + '/self',
    replyTemplates: apiSmsTool + '/reply_templates?template_type=thread',
    apiSentry,
};

const PAGE_SIZE = 25;

export {
    urls,
    PAGE_SIZE,
    crminfo,
    isProductionMode,
};
